import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import FileIcon from "../assets/images/icons/file.svg"
import { formatThaiDate } from "../helps/functions"

const ProcurementContents = ({contents}) => {
  const [prevdata, setPrevdata] = useState(null)
  const [items, setItems] = useState(null)
  const [loaded, setLoaded] = useState(false)
  useEffect(() => {
    if(JSON.stringify(contents) != JSON.stringify(prevdata))
    {
      setLoaded(false)
      const updateContent = contents.sort((a,b) => new Date(b.writing_date) - new Date(a.writing_date))
      setItems(updateContent)
      setPrevdata(contents)
      setLoaded(true)
    }
  },[contents])
  return (
    <>
    {loaded && (
      <ul className="list-group">
        {items?.map((vall, indexx) => (
          <li key={indexx} className="list-group-item ps-4 position-relative">
            <Link to={`/view/ita-procurement/${vall.id}`} className="d-flex text-start">
              <div className='row w-100'>
                <div className='col-md-8 col-sm-8 ps-4'>
                  <img src={FileIcon} className="me-2 position-absolute" style={{left:'10px'}} />{vall.subject}
                </div>
                <div className='col-md-4 col-sm-4 text-end'>
                  <span className='pull-end'>{formatThaiDate(vall.writing_date) }</span>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    )}
    </>
  )
}
export default ProcurementContents